import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Product from '../views/Product.vue'
import OnlineDetail from '../views/OnlineDetail.vue'
import CSDetail from '../views/CSDetail.vue'
import Personal from '../views/personal.vue'
import Tiku from '../views/Tiku.vue'
import Ppt from '../views/Ppt.vue'
import Word from '../views/Word.vue'
import Course from '../views/Course.vue'
import Download from '../views/Download.vue'
import Price from '../views/price.vue'
import Login from '../views/Login.vue'
import NewsMsdn from '../views/news_msdn.vue'
import Computer from '../views/computer.vue'
import Udisk from '../views/udisk.vue'
import Pay from '../views/pay.vue'
import Free from '../views/Free.vue'
import PersonalDan from '../views/personalDan.vue'
import PersonalU from '../views/personalU.vue'
import Update from '../views/update.vue'
import RegAgree from '../views/regAgree.vue'
import Secret from '../views/secret.vue'
import Relief from '../views/relief.vue'
import Anli from '../views/Anli.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/product',
    name: 'Product',
    component: Product
  },
  {
    path: '/onlinedetail',
    name: 'OnlineDetail',
    component: OnlineDetail
  },
  {
    path: '/csdetail',
    name: 'CSDetail',
    component: CSDetail
  },
  {
    path: '/personal',
    name: 'Personal',
    component: Personal
  },
  {
    path: '/tiku',
    name: 'Tiku',
    component: Tiku
  },
  {
    path: '/ppt',
    name: 'Ppt',
    component: Ppt
  },
  {
    path: '/word',
    name: 'Word',
    component: Word
  },
  {
    path: '/course',
    name: 'Course',
    component: Course
  },
  {
    path: '/download',
    name: 'Download',
    component: Download
  },
  {
    path: '/price',
    name: 'Price',
    component: Price
  },
  {
    path: '/personalDan',
    name: 'PersonalDan',
    component: PersonalDan
  },
  {
    path: '/personalU',
    name: 'PersonalU',
    component: PersonalU
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/newsmsdn',
    name: 'NewsMsdn',
    component: NewsMsdn
  },
  {
    path: '/computer',
    name: 'Computer',
    component: Computer
  },
  {
    path: '/udisk',
    name: 'Udisk',
    component: Udisk
  },
  {
    path: '/pay',
    name: 'Pay',
    component: Pay
  },
  {
    path: '/free',
    name: 'Free',
    component: Free
  },
  {
    path: '/update',
    name: 'Update',
    component: Update
  },
  {
    path: '/regAgree',
    name: 'RegAgree',
    component: RegAgree
  },
  {
    path: '/secret',
    name: 'Secret',
    component: Secret
  },
  {
    path: '/relief',
    name: 'Relief',
    component: Relief
  },
  {
    path: '/anli',
    name: 'Anli',
    component: Anli
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.afterEach(() => {
  document.querySelectorAll('body')[0].scrollIntoView({
      // behavior: 'smooth',    //平滑滚动，爽，其他还有 instant
      block: 'start'  //元素到页面顶部，其他还有 end, center
  })
})
export default router
